<template>
  <div class="custom-input">
    <input
      :id="props.inputId"
      v-model="modelValue"
      :type="props.type"
      :class="props.inputClass"
      @keyup.stop
      @keydown.stop />
    <base-icon
      v-if="withClear"
      class="input-clear"
      icon-name="cross"
      width="14"
      height="14"
      viewBox="0 0 28.945 28.945"
      @click="modelValue = null">
      <cross-icon></cross-icon>
    </base-icon>
  </div>
</template>

<script setup lang="ts">
  import { defineModel, defineProps } from "vue";
  import { BaseIcon, CrossIcon } from "@/components/icons";
  const props = withDefaults(
    defineProps<{
      type?: "text" | "checkbox" | "password" | "email" | "password_confirmation" | "number";
      inputClass?: string | null;
      inputId?: string | null;
      withClear?: boolean;
      placeholder?: string;
    }>(),
    {
      type: "text",
      inputClass: null,
      inputId: null,
      withClear: false,
      placeholder: null
    }
  );

  const modelValue = defineModel<string | number | null | boolean>();
</script>
